module.exports = __webpack_public_path__ + "6a846d343d598d040687e5fc959204e9.png";